import { Button, Modal, Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface BundleFormData {
  name: string;
  description: string;
  notes: string;
}

interface BundleFormModalProps {
  show: boolean;
  editing: boolean;
  formData: BundleFormData;
  saving: boolean;
  onClose: () => void;
  onSave: () => void;
  onFieldChange: (field: keyof BundleFormData, value: string) => void;
}

const BundleFormModal = ({
  show,
  editing,
  formData,
  saving,
  onClose,
  onSave,
  onFieldChange,
}: BundleFormModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {editing ? t('warehouses.bundles.editBundle') : t('warehouses.bundles.newBundle')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col md={12}>
              <Form.Group>
                <Form.Label>{t('warehouses.bundles.name')}</Form.Label>
                <Form.Control
                  value={formData.name}
                  onChange={(event) => onFieldChange('name', event.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group>
                <Form.Label>{t('warehouses.bundles.description')}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={formData.description}
                  onChange={(event) => onFieldChange('description', event.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group>
                <Form.Label>{t('warehouses.bundles.notes')}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={formData.notes}
                  onChange={(event) => onFieldChange('notes', event.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('warehouses.scanner.close')}
        </Button>
        <Button variant="primary" onClick={onSave} disabled={saving || !formData.name.trim()}>
          {saving ? '…' : editing ? t('warehouses.bundles.editBundle') : t('warehouses.bundles.newBundle')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BundleFormModal;
